import React, { useState } from 'react';
import {
    IdealBankElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import ModalError from "components/UI/Modal/ModalError";
import { paymentDetailsError, stripePaymentError } from "utils/stripeError";
import './stripeCard.css';

const PaymentIntentIdeal = (props) => {

    const [succeeded, setSucceeded] = useState(false);
    const [error, setError] = useState(null);
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [processing, setProcessing] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [name, setName] = useState('');
    const stripe = useStripe();
    const elements = useElements();
    const clientSecretIdeal = props.clientSecretIdeal;

    const closeModalError = () => {
        setIsOpenModal(false)
    }

    const onChangeName = (event) => {
        setDisabled(event.target.value.length < 1 ? true : false);
        if(event.target.value.length >= 99){
            setError(paymentDetailsError('Use a shorter name', 'Enter the account holder name in fewer than 100 characters.'));
            document.getElementById("card-element").focus();
            setIsOpenModal(true)
            return;
        }
        setName(event.target.value);

        
    }

    const handleChange = async (event) => {
        setDisabled(event.empty || name.length < 1 ? true : false);
        setError(event.error ? stripePaymentError(event.error) : null);
    };

    const handleSubmitStripe = async (event) => {

        event.preventDefault();

        if(document.getElementById("card-element").value.length < 1){
            setError(paymentDetailsError('Enter the account holder name', 'Type the name on the bank account, then pay.'));
            document.getElementById("card-element").focus();
            setIsOpenModal(true)
            return;
        }

        setProcessing(true);

        const clientSecret = clientSecretIdeal;

        const payload = await stripe.confirmIdealPayment(clientSecret, {
            payment_method: {
                ideal: elements.getElement(IdealBankElement),
                billing_details: {
                    name: name,
                  },
            },
            return_url: `${window.location.origin}/Menu/checkout`,
        });

        if (payload.error) {
            console.log("error stripe", payload.error.message)
            setError(stripePaymentError(payload.error));
            setProcessing(false);
            setIsOpenModal(true)
        } else {
            console.log("Stripe status", payload.status)
            setError(null);
            setProcessing(false);
            setSucceeded(true);
        }
    }

    return (

        <form className="payment-form" onSubmit={handleSubmitStripe} ref={props.formReference}>

            <label className="payment-details">Payment Ideal Details</label>
            <div className="stripe-card">

                <label>Name</label>
                <input type="text" id="card-element" value={name} onChange={onChangeName} maxlength="99"/>
                
                <label className="idealBankElement" htmlFor="ideal-bank-element">Bank</label>
                <IdealBankElement id="card-element" onChange={handleChange}/>

                <button className="buttonStripe"
                    disabled={processing || disabled || succeeded}
                    id="submit"
                    type="submit"
                >
                    <span id="button-text">
                        {processing ? (<div className="spinner" id="spinner"></div>) : ("PAY NOW")}
                    </span>
                </button>

                <ModalError
                    style={{ zIndex: "99999", position: "absolute", margin: "5% 26%" }}
                    showModal={isOpenModal}
                    closeModal={closeModalError}
                    errorMessage={error}
                />

            </div>
        </form>
    )
}

export default PaymentIntentIdeal;


// WEBPACK FOOTER //
// ./src/containers/Checkout/Stripe/stripeIdeal.js